<template>
  <div>
    <!-- button -->
    <b-button
      id="toggle-btn"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-b-modal.modal-prevent-closing
      modal-sm
      variant="primary"
    >
      Adicionar Módulo
    </b-button>
    <!-- modal -->
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      centered
      title="Adicionar módulo"
      ok-title="Adicionar módulo"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        @submit.stop.prevent="handleSubmit"
      >
        <b-form-group
          :state="nameState"
          label="Nome do módulo"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-input
            id="name-input"
            v-model="moduloAddData.modulo_name"
            :state="nameState"
            required
          />
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import formValidation from '@core/comp-functions/forms/form-validation'
import useModulosList from '@/views/App/Treinamentos/TreinamentosAdmin/useModulosList'
import moduloTreStore from '@/store/ModuloTrei/moduloTreStore'

export default {
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  data() {
    return {
      nameState: null,
    }
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.moduloAddData.modulo_name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Call the onSubmit method to dispatch the addModulo action from the store
      this.onSubmit()
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
      this.$emit('onSubmit')
    },
    abrirModal() {
      this.$bvModal.show('modal-prevent-closing')
    },
  },
  setup() {
    const blankModuloData = {
      modulo_name: '',
      modulo_ativo: 1,
      modulo_ordem: 0,
    }
    const refreshEvent = new Event('refresh')

    const USER_APP_STORE_MODULE_NAME = 'app-modulo'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, moduloTreStore)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const moduloAddData = ref(JSON.parse(JSON.stringify(blankModuloData)))
    const resetuserData = () => {
      moduloAddData.value = JSON.parse(JSON.stringify(blankModuloData))
    }

    const onSubmit = async () => {
      store.dispatch('app-modulo/addModulo', moduloAddData.value)
        .then(() => {
          window.dispatchEvent(refreshEvent)
          // await refetchData()
        })
        .catch(error => {
          console.log('error', error)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    const {
      moduloData,
      refetchData,
    } = useModulosList()
    return {
      moduloAddData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
      moduloData,
      refetchData,
    }
  },
  methos: {
    modal_prevent() {
      console.log('modal_prevent')
    },
  },
}
</script>
